import { indefiniteArticle } from './indefiniteArticle';
var formatters = {
    indefiniteArticle: indefiniteArticle,
};
export var customFormatters = {
    type: '3rdParty',
    init: function (instance) {
        if (instance.services.formatter) {
            for (var _i = 0, _a = Object.entries(formatters); _i < _a.length; _i++) {
                var _b = _a[_i], formatterName = _b[0], formatterFunction = _b[1];
                instance.services.formatter.add(formatterName, formatterFunction);
            }
        }
    },
};
//# sourceMappingURL=index.js.map